angular.module('ecrd')
    .factory('EntityMenuPluginNotes', [
        'RecordQueriesService',
        'CrfService',
        'RecordDataService',
        'AccountManager',
        'FormFieldsService',
        function(RecordQueriesService, CrfService, RecordDataService, AccountManager, FormFieldsService) {
            /**
             * Obtiene un resumen con el número de queries en campos visibles del formulario
             *
             * @param  {Structure.Form} form        Instancia del formulario
             * @param  {object}         listIndices Índices de las listas a las que pertenece el formulario
             *
             * @return {object}                     Contador de queries sobre campos visibles, por estado
             */
            function getFormNotesInfo(form, listIndices) {
                var result = {
                    total: 0,
                    new: 0,
                    updated: 0,
                    resolutionProposed: 0,
                    closed: 0,
                };

                var allQueries = RecordQueriesService.getQueries();

                // A partir de las queries existentes detectamos las que pertenezcan al formulario en cuestión
                // Sabemos que el aspecto de las claves es un string que representa un UID con los componentes
                // separados por puntos
                var formUid = RecordDataService.getElementUID(form.getId(), listIndices);
                if (!formUid) {
                    return result;
                }
                // De modo que primero calculamos el UID del formulario y le quitamos la componente final, para que
                // todos los campos que contiene compartan el mismo prefijo
                var uidPrefix = formUid.slice(0, -1);

                angular.forEach(form.getFields(), function(field) {
                    var fieldId = field.getId();
                    if (FormFieldsService.isElementVisible(fieldId, listIndices)) {
                        var fieldKey = uidPrefix.concat(fieldId).join('.');
                        // El campo es visible y tiene queries registradas, las acumulamos
                        if (fieldKey in allQueries) {
                            // Este proceso es el mismo que hace el core de queries en _calculateQueriesMetainfo
                            angular.forEach(allQueries[fieldKey], function(query) {
                                result.total++;

                                var lastText = query.lastText ? query.lastText : query.texts[query.texts.length - 1];
                                var statusKey = lastText.status === 'resolution_proposed'
                                    ? 'resolutionProposed'
                                    : lastText.status;

                                result[statusKey]++;
                            });
                        }
                    }
                });

                return result;
            }

            function getSectionNotesInfo(section, listIndices) {
                return section.getChildren().reduce(function(acc, child) {
                    var childInfo = {};

                    if (FormFieldsService.isElementVisible(child.getId(), listIndices)) {
                        if (child.isForm()) {
                            childInfo = getFormNotesInfo(child, listIndices);
                        } else if (child.isSection()) {
                            childInfo = getSectionNotesInfo(child, listIndices);
                        } else if (child.isList()) {
                            childInfo = getListNotesInfo(child, listIndices);
                        }
                    }

                    return sumQueriesInfo(acc, childInfo);
                }, {});
            }

            function getListNotesInfo(list, listIndices) {
                var listData = RecordDataService.getList(list.getId(), listIndices);
                if (!angular.isArray(listData) || listData.length === 0) {
                    return;
                }

                listIndices = listIndices || {};

                return listData.reduce(function(acc, itemData, index) {
                    var itemIndices = angular.copy(listIndices);
                    itemIndices[list.getId()] = index + 1;

                    var itemInfo = getListItemNotesInfo(list, itemIndices);

                    return sumQueriesInfo(acc, itemInfo);
                }, {});
            }

            function getListItemNotesInfo(list, listIndices) {
                return getSectionNotesInfo(list, listIndices);
            }

            function mergeQueries(itemMetadata, queries) {
                if (angular.isUndefined(itemMetadata.notes)) {
                    itemMetadata.notes = queries;
                } else {
                    angular.extend(itemMetadata.notes, queries);
                }
            }

            function sumQueriesInfo(notesInfo1, notesInfo2) {
                var result = angular.extend({}, notesInfo1);

                for (var key in notesInfo2) {
                    if (key in result) {
                        result[key] += notesInfo2[key];
                    } else {
                        result[key] = notesInfo2[key];
                    }
                }

                return result;
            }

            function reloadInfo(itemMetadata, sectionId, sectionType, sectionState, stateParams) {
                var element = itemMetadata.element;
                var listIndices = CrfService.getListIndices(stateParams);
                var notes = {};

                if (sectionType === 'form') {
                    notes = getFormNotesInfo(element, listIndices);
                } else if (sectionType === 'section') {
                    notes = getSectionNotesInfo(element, listIndices);
                } else if (sectionType === 'list') {
                    notes = getListNotesInfo(element, listIndices);
                } else if (sectionType === 'listItem') {
                    notes = getListItemNotesInfo(element, listIndices);
                }

                mergeQueries(itemMetadata, notes);

                return true;
            }

            return {
                buildAccess: function(access) {
                    access.queries = AccountManager.hasPermission('read records queries');
                },
                initFormFlags: function(itemMetadata, sectionId, entityData, stateParams) {
                    var listIndices = CrfService.getListIndices(stateParams);
                    mergeQueries(itemMetadata, getFormNotesInfo(itemMetadata.element, listIndices));

                    return true;
                },
                initSectionFlags: function(itemMetadata, elementId, entityData, stateParams) {
                    var section = itemMetadata.element;
                    if (section) {
                        var listIndices = CrfService.getListIndices(stateParams);
                        mergeQueries(itemMetadata, getSectionNotesInfo(section, listIndices));
                    }
                },
                initListFlags: function(itemMetadata, elementId, entityData, stateParams) {
                    var list = itemMetadata.element;
                    if (list) {
                        var listIndices = CrfService.getListIndices(stateParams);
                        mergeQueries(itemMetadata, getListNotesInfo(list, listIndices));
                    }
                },
                initListItemFlags: function(itemMetadata, elementId, stateParams) {
                    var list = itemMetadata.element;
                    if (list) {
                        var listIndices = CrfService.getListIndices(stateParams);
                        mergeQueries(itemMetadata, getListItemNotesInfo(list, listIndices, itemMetadata.id));
                    }
                },
                onEntityNotesUpdated: reloadInfo,
                onElementFlagChangedVisibility: function(argumentsList) {
                    var itemMetadata = argumentsList[0];
                    // var elementId = argumentsList[1];
                    // var stateParams = argumentsList[2];
                    var listIndices = argumentsList[3].listIndices;

                    var notes = {};

                    if (itemMetadata.type === 'form') {
                        notes = getFormNotesInfo(itemMetadata.element, listIndices);
                    } else if (itemMetadata.type === 'section') {
                        notes = getSectionNotesInfo(itemMetadata.element, listIndices);
                    } else if (itemMetadata.type === 'list') {
                        notes = getListNotesInfo(itemMetadata.element, listIndices);
                    } else if (itemMetadata.type === 'listItem') {
                        notes = getListItemNotesInfo(itemMetadata.element, listIndices);
                    }

                    mergeQueries(itemMetadata, notes);

                    return true;
                },
                reloadFlags: reloadInfo,
            };
        },
    ]);
